<form clrForm>

  <clr-toggle-container>
    <clr-toggle-wrapper>
      <input type="checkbox" clrToggle [(ngModel)]="buttonConfig.EmitsOutputParameter" name="parameterbutton"/>
      <label>Emit output parameter</label>
    </clr-toggle-wrapper>
  </clr-toggle-container>

  <clr-select-container *ngIf="buttonConfig.EmitsOutputParameter">
    <label>Data type</label>
    <select clrSelect name="coltype" [(ngModel)]="buttonConfig.DataType">
      <option [ngValue]="OutputDataType.Float32">Float32</option>
      <option [ngValue]="OutputDataType.Float64">Float64</option>
      <option [ngValue]="OutputDataType.UInt8">UInt8</option>
      <option [ngValue]="OutputDataType.Int32">Int32</option>
      <option [ngValue]="OutputDataType.Int64">Int64</option>
      <!-- <option value="5">Number</option> -->
      <option [ngValue]="OutputDataType.Timestamp">Timestamp</option>
      <option [ngValue]="OutputDataType.String">String</option>
      <option [ngValue]="OutputDataType.RelativeTimestamp">Relative Timestamp</option>
    </select>
  </clr-select-container>

  <clr-datagrid [(clrDgSingleSelected)]="selectedButton">
    <clr-dg-column>Label</clr-dg-column>
    <clr-dg-column>Value</clr-dg-column>
    <clr-dg-column *ngIf="buttonConfig.DataType == OutputDataType.RelativeTimestamp" >Offset</clr-dg-column>
    <clr-dg-column *ngIf="buttonConfig.DataType == OutputDataType.RelativeTimestamp" >Offset Type</clr-dg-column>
    <clr-dg-column>Type</clr-dg-column>
    <clr-dg-column>Default</clr-dg-column>
    <clr-dg-column>Move</clr-dg-column>

    <clr-dg-row *ngFor="let button of buttonConfig.Buttons; let i = index" [clrDgItem]="button">
      <clr-dg-cell>
        <input class="clr-input" placeholder="" name="Label{{i}}" [(ngModel)]="button.Label" />
      </clr-dg-cell>
      <clr-dg-cell>
        <input *ngIf="buttonConfig.DataType < 6" class="clr-input" type="number" placeholder="" name="Value{{i}}" [(ngModel)]="button.ValueNumber" />
        <input *ngIf="buttonConfig.DataType == 6" class="clr-date" type="date" name="Value{{i}}" [(clrDate)]="button.ValueDate">
        <input *ngIf="buttonConfig.DataType == 7" class="clr-input" type="string" placeholder="" name="Value{{i}}" [(ngModel)]="button.ValueString" />
        <div *ngIf="buttonConfig.DataType == OutputDataType.RelativeTimestamp" class="clr-select-wrapper">
          <select class="clr-select" name="Value{{i}}" [(ngModel)]="button.ValueNumber">
            <option [ngValue]="RelativeTimestampOrigo.NOW"> Now </option>
            <option [ngValue]="RelativeTimestampOrigo.NOWUTC"> Utc Now </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_YEAR"> Beginning of this year </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_MONTH"> Beginning of this month </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_DAY"> Beginning of this day </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_HOUR"> Beginning of this hour </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_MINUTE"> Beginning of this minute </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_YEARUTC"> UTC Beginning of this year </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_MONTHUTC"> UTC Beginning of this month </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_DAYUTC"> UTC Beginning of this day </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_HOURUTC"> UTC Beginning of this hour </option>
            <option [ngValue]="RelativeTimestampOrigo.BEGINNING_OF_THIS_MINUTEUTC"> UTC Beginning of this minute </option>
          </select>
        </div>
      </clr-dg-cell>
      <clr-dg-cell *ngIf="buttonConfig.DataType == OutputDataType.RelativeTimestamp">
        <input class="clr-input" type="number" placeholder="" name="Value2{{i}}" [(ngModel)]="button.ValueNumber2" />
      </clr-dg-cell>
      <clr-dg-cell *ngIf="buttonConfig.DataType == OutputDataType.RelativeTimestamp">
        <div class="clr-select-wrapper">
          <select class="clr-select" name="Value3{{i}}" [(ngModel)]="button.ValueNumber3">
            <option [ngValue]="OffsetType.YEAR"> Year </option>
            <option [ngValue]="OffsetType.MONTH"> Month </option>
            <option [ngValue]="OffsetType.DAY"> Day </option>
            <option [ngValue]="OffsetType.HOUR"> Hour </option>
            <option [ngValue]="OffsetType.MINUTE"> Minute </option>
            <option [ngValue]="OffsetType.SECOND"> Second </option>
          </select>
        </div>
      </clr-dg-cell>
      <clr-dg-cell>
        <div class="clr-select-wrapper">
          <select class="clr-select" name="buttontype{{i}}" [(ngModel)]="button.ButtonType">
            <option [ngValue]="ButtonType.REGULAR"> Regular </option>
            <option [ngValue]="ButtonType.SUCCESS"> Success </option>
            <option [ngValue]="ButtonType.INFO"> Info </option>
            <option [ngValue]="ButtonType.WARNING"> Warning </option>
            <option [ngValue]="ButtonType.DANGER"> Danger </option>
          </select>
        </div>
      </clr-dg-cell>
      <clr-dg-cell>
        <input class="clr-checkbox" type="checkbox" placeholder="" name="Default{{i}}" [(ngModel)]="button.Default" (change)="defaultClick(button)"/>
      </clr-dg-cell>
      <clr-dg-cell>
        <clr-icon (click)="moveButtonUp(i);" shape="circle-arrow" [style.cursor]="'pointer'"></clr-icon>
        <clr-icon (click)="moveButtonDown(i);" shape="circle-arrow" [style.cursor]="'pointer'"
          style="margin-left: 1em; transform: rotate(180deg);"></clr-icon>
      </clr-dg-cell>
    </clr-dg-row>
  </clr-datagrid>

  <button type="button" class="btn btn-link" (click)="addButton()">
    <clr-icon shape="plus-circle"></clr-icon>
    Add Button
  </button>
  <button *ngIf="selectedButton" type="button" class="btn btn-link" (click)="removeSelectedButton()">
    <clr-icon shape="minus-circle"></clr-icon>
    Remove selected button
  </button>

  <clr-toggle-container *ngIf="selectedButton">
    <clr-toggle-wrapper>
      <input type="checkbox" clrToggle [(ngModel)]="selectedButton.ScriptedAction" name="actionbutton"/>
      <label>Scripted action</label>
    </clr-toggle-wrapper>
  </clr-toggle-container>

  <ngx-monaco-editor *ngIf="selectedButton && selectedButton.ScriptedAction" [style]="selectedButton.ScriptedActionLuaScript==''?'height:2em;':'height:20em;'" name="editbuttonscript" [options]="editorOptionsLua" [(ngModel)]="selectedButton.ScriptedActionLuaScript">
  </ngx-monaco-editor>  

</form>
